import { SERVICES, LEGACY_SLUGS, HERO_IMAGE } from "@/components/site/data";
import { SERVICE_CONTENT } from "@/components/site/serviceContent";
import { AREAS_HUB, TOWNS, findTown } from "@/components/site/areaContent";
import { localBusinessSchema, serviceSchema, faqSchema, breadcrumbSchema, breadcrumbList, areaServiceSchema, areasHubSchema } from "@/components/site/structuredData";

export const areasHubMeta = () => ({
  title: AREAS_HUB.metaTitle,
  description: AREAS_HUB.metaDescription,
  path: "/areas",
  image: HERO_IMAGE,
  jsonLd: [areasHubSchema(TOWNS), breadcrumbList([["Home", "/"], ["Service Areas", "/areas"]])],
});

export const areaMeta = (town) => ({
  title: town.metaTitle,
  description: town.metaDescription,
  path: `/areas/${town.slug}`,
  image: HERO_IMAGE,
  jsonLd: [
    areaServiceSchema(town),
    faqSchema(town.faqs),
    breadcrumbList([["Home", "/"], ["Service Areas", "/areas"], [town.name, `/areas/${town.slug}`]]),
  ],
});

export const homeMeta = () => ({
  title: "JMS Technologies | Business Technology Solutions in Chatham-Kent",
  description: "JMS Technologies: modern business technology in Chatham-Kent. IT and computers, Microsoft 365, networking and Wi-Fi, VoIP phones, security cameras and advertisement TVs. Call 226-626-3220.",
  path: "/",
  image: HERO_IMAGE,
  jsonLd: [localBusinessSchema()],
});

export const serviceMeta = (service) => {
  const c = SERVICE_CONTENT[service.id];
  return {
    title: c.metaTitle,
    description: c.metaDescription,
    path: `/services/${service.slug}`,
    image: service.image,
    jsonLd: [serviceSchema(service, c), faqSchema(c.faqs), breadcrumbSchema(service)],
  };
};

export const notFoundMeta = () => ({
  title: "Page Not Found | JMS Technologies",
  description: "Sorry, we couldn't find that page. Explore JMS Technologies' business technology services in Chatham-Kent.",
  noindex: true,
});

export const routeMeta = (pathname) => {
  const p = pathname.replace(/\/+$/, "") || "/";
  if (p === "/" || p === "/services") return { status: 200, renderPath: "/", meta: homeMeta() };
  if (p === "/areas") return { status: 200, renderPath: p, meta: areasHubMeta() };
  const a = p.match(/^\/areas\/([^/]+)$/);
  const town = a && findTown(a[1]);
  if (town) return { status: 200, renderPath: p, meta: areaMeta(town) };
  const m = p.match(/^\/services\/([^/]+)$/);
  if (m && LEGACY_SLUGS[m[1]]) return { status: 301, redirect: `/services/${LEGACY_SLUGS[m[1]]}` };
  const service = m && SERVICES.find((s) => s.slug === m[1]);
  if (service) return { status: 200, renderPath: p, meta: serviceMeta(service) };
  return { status: 404, renderPath: p, meta: notFoundMeta() };
};
